"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _couponEAct = _interopRequireDefault(require("./couponEAct.vue"));
var _expandList = _interopRequireDefault(require("./expandList.vue"));
var _couponEAdd = _interopRequireDefault(require("./couponEAdd.vue"));
var _extraReward = _interopRequireDefault(require("./extraReward.vue"));
var _extraRewardAdd = _interopRequireDefault(require("./extraRewardAdd.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '券膨胀活动',
  components: {
    expandList: _expandList.default,
    couponEAct: _couponEAct.default,
    couponEAdd: _couponEAdd.default,
    extraRewardAdd: _extraRewardAdd.default,
    extraReward: _extraReward.default
  },
  data: function data() {
    return {
      refresh: false,
      actTitle: null,
      actId: null,
      loading: false,
      activeTab: 'couponEAct',
      tabs: ['couponEAct', 'expandList']
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    saved: function saved() {
      this.activeTab = 'couponEAct';
      this.refresh = true;
    },
    addAct: function addAct() {
      this.activeTab = 'couponEAdd';
      this.actId = null; // 新增时清空
    },
    handleEdit: function handleEdit(row) {
      this.activeTab = 'couponEAdd';
      this.actId = row.id;
    },
    handleCopy: function handleCopy(row) {
      this.activeTab = 'couponEAdd';
      this.actId = row.id + '_copy';
    },
    detailUser: function detailUser(row) {
      this.activeTab = 'expandList';
      // this.actTitle = row.activityName;
      this.actId = row.id;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
      this.actId = null;
    },
    removeTab: function removeTab(tabName) {
      // const index = this.tabs.indexOf(tabName)
      // if (index !== -1) this.tabs.splice(index, 1)
      // if (this.activeTab === tabName) {
      //     this.activeTab = 'taskList'
      // }
    }
  },
  mounted: function mounted() {}
};